import { useNavigate } from 'react-router-dom'

export const PREPARATION_URL =
  '/assembly/detail/:transferId/:docNum/preparation'

export const useGoToPreparation = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string) => {
      navigate(
        PREPARATION_URL.replace(':transferId', transferId).replace(
          ':docNum',
          docNum
        )
      )
    }
  }
}
